/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import { ActionSheet as x, ActionSheetFooter as v } from "@progress/kendo-react-layout";
import { xIcon as C } from "@progress/kendo-svg-icons";
import { Button as o } from "@progress/kendo-react-buttons";
import { useAdaptiveModeContext as g } from "@progress/kendo-react-common";
const A = (i) => {
  const {
    windowWidth: l = 0,
    children: c,
    navigatable: r,
    navigatableElements: s,
    expand: m,
    animation: p,
    title: d,
    subTitle: b,
    footer: e,
    onClose: n
  } = i, f = () => /* @__PURE__ */ t.createElement(
    o,
    {
      tabIndex: 0,
      "aria-label": "Cancel",
      "aria-disabled": "false",
      type: "button",
      fillMode: "flat",
      icon: "x",
      svgIcon: C,
      onClick: n
    }
  ), a = g(), h = {
    navigatable: r || !1,
    navigatableElements: s || [],
    expand: m,
    animation: p,
    actions: f(),
    onClose: n,
    animationStyles: a && l <= a.small ? { top: 0, width: "100%", height: "100%" } : void 0,
    title: d,
    subTitle: b,
    className: "k-adaptive-actionsheet",
    position: a && l <= a.small ? "fullscreen" : void 0
  };
  return /* @__PURE__ */ t.createElement(x, { ...h }, c, /* @__PURE__ */ t.createElement(v, { className: "k-actions k-actions-stretched" }, /* @__PURE__ */ t.createElement(
    o,
    {
      size: "large",
      className: "k-coloreditor-cancel",
      "aria-label": e.cancelText,
      onClick: e.onCancel
    },
    e.cancelText
  ), /* @__PURE__ */ t.createElement(
    o,
    {
      themeColor: "primary",
      size: "large",
      className: "k-coloreditor-apply",
      "aria-label": e.applyText,
      onClick: e.onApply
    },
    e.applyText
  )));
};
export {
  A as AdaptiveMode
};
